import type React from 'react';

import { ThemeProvider } from '@change/ds-core-ui';

import { AmountButton } from 'src/app/shared/components/payments';

import { AmountInput } from './components/AmountInput';
import { MultipleAmountSelector } from './components/MultiplePricesExperiment/MultipleAmountSelector';
import { SliderAmountSelector } from './components/MultiplePricesExperiment/SliderAmountSelector';
import { useAmountSelector } from './hooks/useAmountSelector';

export const AmountSelector: React.FC = () => {
	const {
		data: {
			amount,
			currency,
			currencySymbol,
			errorMessage,
			isSelected,
			value,
			placeholder,
			amountButtonProps,
			acceptMembership,
			revenuePpmuMultiplePricesExpDataVariant,
		},
		actions: { onChange, onClick, onFocus },
	} = useAmountSelector();

	return (
		<ThemeProvider>
			{revenuePpmuMultiplePricesExpDataVariant === 'variant_1' && <SliderAmountSelector />}
			{revenuePpmuMultiplePricesExpDataVariant === 'variant_2' && <MultipleAmountSelector />}
			{revenuePpmuMultiplePricesExpDataVariant === 'variant_3' && <SliderAmountSelector layout="maxInline" />}
			{revenuePpmuMultiplePricesExpDataVariant === 'variant_4' && <SliderAmountSelector layout="labelsBelow" />}
			{revenuePpmuMultiplePricesExpDataVariant === 'control' && (
				<div className="flex w-full justify-center gap-2 pt-3 pb-1">
					<div className="basis-1/4">
						<AmountButton
							dataQaAttribute="default-amount-button"
							amount={amount}
							currency={currency}
							isSelected={acceptMembership && isSelected}
							onClick={onClick}
							height={amountButtonProps.buttonHeight}
							{...amountButtonProps}
							isSunriseEnabled
						/>
					</div>
					<div className="basis-3/4">
						<AmountInput
							currencySymbol={currencySymbol}
							errorMessage={errorMessage}
							onChange={onChange}
							onFocus={onFocus}
							value={value}
							placeholder={placeholder}
							height={amountButtonProps.buttonHeight}
						/>
					</div>
				</div>
			)}
		</ThemeProvider>
	);
};
